import { render, staticRenderFns } from "./RecipeAdd2.vue?vue&type=template&id=4684e738&scoped=true&"
import script from "./RecipeAdd2.vue?vue&type=script&lang=js&"
export * from "./RecipeAdd2.vue?vue&type=script&lang=js&"
import style0 from "./RecipeAdd2.vue?vue&type=style&index=0&id=4684e738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684e738",
  null
  
)

export default component.exports